import { render, staticRenderFns } from "./CarInsurance.vue?vue&type=template&id=4f20dd88&scoped=true"
import script from "./CarInsurance.vue?vue&type=script&lang=ts"
export * from "./CarInsurance.vue?vue&type=script&lang=ts"
import style0 from "./CarInsurance.vue?vue&type=style&index=0&id=4f20dd88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f20dd88",
  null
  
)

export default component.exports